import { StyledVersionedRouterLink } from '#/components/Link/StyledVersionedRouterLink';
import type { I18nFn } from '#/i18n/types/I18nFn';
import type { I18nLocale } from '#/i18n/types/I18nLocale';
import type { ApiOrg } from '#/modules/listing/orgs/api/types/ApiOrg';

import { getCityStateString } from './address/getCityStateString';

type DuplicateNameOrgData = Pick<ApiOrg, 'name' | 'url'> & {
  address?: Partial<ApiOrg['address']>;
  city?: string;
  stateCode?: string;
  state?: string;
  country?: string;
};

export function duplicateNameError(
  i18n: I18nFn,
  locale: I18nLocale,
  org: DuplicateNameOrgData,
) {
  const address =
    org.address ??
    ({
      city: org.city,
      stateCode: org.stateCode,
      state: org.state,
      country: org.country,
    } satisfies DuplicateNameOrgData['address']);

  return (
    <>
      {i18n(
        'There is already an organization account for %(orgName)s in %(orgLocation)s. If this is your organization, please {{link}}click here to request administrator access{{/link}}.',
        {
          orgName: org.name,
          orgLocation: getCityStateString(i18n, address ?? {}),
          link: (
            <StyledVersionedRouterLink
              qaId="existing-org-link"
              target="existing_org"
              to={org.url[locale]}
            />
          ),
        },
      )}
    </>
  );
}
